<template>
  <div class="page-base">
    <div class="g-wrap">
      <column-header2 :data="baseMeta"></column-header2>
      <div class="column-wrap intro-wrap">
        <div class="left">
          <div class="content" v-html="baseData.TrainingSystem"></div>
          <!-- <router-link class="link" :to="`${$subsitePrefix}/company/info`"
            >查看详细+</router-link
          > -->
        </div>
        <div class="right">
          <img @error="imgError" :src="baseData.TrainingImg" :alt="baseMeta.Name" />
        </div>
      </div>
    </div>
    <div class="mentor-wrap">
      <div class="g-wrap">
        <column-header2 :data="mentorMeta"></column-header2>
        <div class="column-wrap">
          <mentor-card v-for="item in mentorList" :data="item" :key="item.Id"></mentor-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColumnHeader from "_c/ColumnHeader2";
import MentorCard from "./MentorCard";
import { getData, getDetail } from "api/app";
export default {
  name: "panel-talent",
  data() {
    return {
      baseMeta: {
        name: "人才培养体系"
      },
      mentorMeta: {
        name: "导师团队",
        link: `${this.$subsitePrefix}/company/mentor/list/${this.$route.params.id}`
      },
      baseData: {
        content: "",
        id: "",
        pic: ""
      },
      mentorList: [],
      id: this.$route.params.id
    };
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [MentorCard.name]: MentorCard
  },
  methods: {
    loadData() {
      getDetail({ name: "Enterprise", id: this.id }).then(res => {
        this.baseData = res || {};
      });
      getData({
        name: "EnterpriseTutor",
        top: 3,
        params: [{ Key: "Enterprise", Value: this.id, CompareType: "EqualTo" }]
      }).then(res => {
        this.mentorList = res || [];
      });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-base {
  .column-wrap {
    display: flex;
    justify-content: space-between;
  }
  .intro-wrap {
    height: 266px;
    padding-bottom: 40px;
    .left {
      width: 768px;
      color: rgba(102, 102, 102, 1);
      line-height: 28px;
      .content {
        ::v-deep p {
          text-indent: 2em;
        }
      }
      .link {
        color: $primary-color;
        &:hover {
          color: $link-active-color;
        }
      }
    }
    .right {
      width: 376px;
      height: 266px;
      overflow: hidden;
      border-radius: 8px;
    }
  }
  .mentor-wrap {
    background-color: #f6f6f9;
    padding-bottom: 16px;
    .column-wrap {
      flex-wrap: wrap;
    }
  }
}
</style>
